import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/service/hotlineList',
    name: 'serviceHotlineList',
    component: () => import('@/sub-app/service/pages/hotlineList.vue'),
    meta: {
      title: '',
      keepAlive: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  document.title = to.meta?.title || '';
  next();
});

export default router;
